<template>
    <div class="sub-head">
        <div class="sub-visual" :class="{ 'sub-visual--sub-tab': subTab }">
            <div class="sub-visual__inner">
                <v-container>
                    <div class="sub-visual__tit-wrap">
                        <h2 class="sub-visual__tit">{{ sh }}</h2>
                    </div>
                </v-container>
            </div>
            <div class="sub-visual__bg" :style="'background-image:url(' + bg + ');'"></div>
        </div>
        <div class="sub-head__bottom" v-if="subTab">
            <v-container>
                <div class="sub-head__bottom__inner">
                    <v-row no-gutters align="center">
                        <v-col cols="auto" class="d-none d-md-block">
                            <div class="sub-index d-flex justify-center align-center px-20 px-xl-80">
                                <p class="font-weight-bold white--text">{{ index }}</p>
                                <span class="d-inline-block mx-10 mx-lg-14">l</span>
                                <p>{{ total }}</p>
                            </div>
                        </v-col>
                        <v-spacer class="d-none d-md-block" />
                        <v-col cols="12" md="auto">
                            <client-gnb className="sub-tab-wrap" :tabActive="tabActive" :sh="sh"></client-gnb>
                        </v-col>
                    </v-row>
                </div>
            </v-container>
        </div>
    </div>
</template>

<script>
import ClientGnb from "@/components/client/en/inc/client-gnb.vue";

export default {
    props: {
        sh: { type: String, default: "" },
        bg: { type: String, default: "" },
        tabActive: { type: String, default: "" },
        index: { type: String, default: "" },
        total: { type: String, default: "" },
        subTab: { type: Boolean, default: false },
    },
    components: {
        ClientGnb,
    },
    data: () => {
        return {};
    },
    created() {},
};
</script>

<style lang="scss" scoped>
.sub-head {
    position: relative;
}
/* sub-visual */
.sub-visual {
    position: relative;
    height: 200px;
}
.sub-visual__tit {
    font-size: 3.6rem;
    font-weight: 700;
    color: #fff;
}
.sub-visual__bg {
    position: absolute;
    top: 0;
    left: 50%;
    z-index: 0;
    -webkit-transform: translate(-50%, 0);
    -ms-transform: translate(-50%, 0);
    transform: translate(-50%, 0);
    width: 100vw;
    height: 100%;
    background-repeat: no-repeat;
    background-position: center;
    background-size: cover;
}
.sub-visual__inner {
    width: 100%;
    height: 100%;
    position: relative;
    z-index: 1;
}
.sub-visual__inner .container {
    height: 100%;
}
.sub-visual__tit-wrap {
    height: 100%;
    display: flex;
    align-items: center;
}
@media (min-width: 576px) {
}
@media (min-width: 768px) {
    .sub-visual {
        height: 320px;
    }
    .sub-visual__tit {
        font-size: 5rem;
    }
    .sub-visual--sub-tab {
        padding-bottom: 44px;
    }
    .sub-visual--sub-tab .sub-visual__tit-wrap {
        border-right: 1px solid rgba(255, 255, 255, 0.25);
    }
}
@media (min-width: 1024px) {
    .sub-visual {
        height: 480px;
        padding-top: 0;
    }
    .sub-visual__tit {
        font-size: 7.2rem;
    }
    .sub-visual--sub-tab {
        padding-bottom: 80px;
    }
}
@media (min-width: 1200px) {
    .sub-visual {
        padding-top: var(--header-body);
    }
}

/* sub-tab-wrap */
.sub-head__bottom {
    width: 100%;
    position: relative;
}
.sub-tab-wrap {
    width: 100%;
}
.sub-head__bottom .container {
    padding: 0;
}

.sub-index {
    font-size: 1.4rem;
    line-height: 1;
    color: rgba(255, 255, 255, 0.4);
}
@media (min-width: 768px) {
    .sub-tab-wrap {
        display: flex;
        justify-content: flex-end;
    }
    .sub-head__bottom .container {
        padding: 0 12px;
    }
    .sub-head__bottom__inner {
        border-right: 1px solid rgba(255, 255, 255, 0.25);
        border-left: 1px solid rgba(255, 255, 255, 0.25);
    }
    .sub-head__bottom {
        position: absolute;
        z-index: 4;
        left: 0;
        bottom: 0;
        border-top: 1px solid rgba(255, 255, 255, 0.25);
    }
}
@media (min-width: 1024px) {
    .sub-index {
        font-size: 1.6rem;
    }
}
</style>
